<template>
    <div class="m-subheader ">
        <div class="d-flex align-items-center">
            <div class="mr-auto">
                <h3 class="m-subheader__title " v-html="$t(headerTitle)">
                </h3>
            </div>
            <div v-if="!disable">
                <!--<a href="#" class="btn btn-link m-btn m-btn--icon m-btn--pill m-btn--air" v-if="!noexport">
                    <i class="flaticon-graphic-1"></i>
                    {{$t('Export')}}
                </a>-->
                <router-link :to="addNewLink" class="btn btn-success m-btn m-btn--icon m-btn--pill m-btn--air" v-if="!nonew">
                    <i class="flaticon-edit-1"></i>
                    {{$t('Add new')}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SubHeader',
  props: {
    headerTitle: {
      type: String
    },
    addNewLink: {
      type: String
    },
    disable: {
      type: Boolean,
      default: false
    },
    noexport: {
      type: Boolean,
      default: false
    },
    nonew: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/SubHeader.vue